
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// Constants
import Assets from '@/constants/assets.ts';

@Component
export default class FormView extends Vue {
  @Prop({ default: true }) private showClose!: boolean;
  @Prop({ default: false }) private showDecoration!: boolean;
  @Prop({ default: '', type: [String, Object] }) private backgroundImage!:
    | string
    | {};
  @Prop({ default: false }) private overflowAuto!: boolean;
  @Prop({ default: false }) private overflowHidden!: boolean;
  @Prop({ default: false }) private withOutPadding!: boolean;
  @Prop({ default: false }) private overflowVisible!: boolean;

  private assets = Assets;

  get backgroundImg() {
    const bg = {
      'background-image': `url("${this.assets.navbarBg}")`,
    };
    try {
      return this.$route.query.specialAnnouncement ? bg : this.backgroundImage;
    } catch (_) {
      return this.backgroundImage;
    }
  }

  get specialAnnouncement() {
    return this.$route.query.specialAnnouncement;
  }

  private clickClose() {
    this.$emit('close-click');
  }
}
